import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TextControl } from '../InputControls';
import CartIcon from '../../icons/cart';
import { makeRequest, validateEmail, updateCartState } from '../../utils';
import { useRecoilState } from 'recoil';
import { cartState } from '../../atoms';
import AddToCart from '../AddToCart';
import './style.css';

export default function AboutPage() {
  const [cart, setCart] = useRecoilState(cartState);

  document.title = `All Titles | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `All titles from Series One and Series Two`);

  const addToCart = (item) => {
    let newCart = updateCartState(cart, item);
    setCart(newCart);
  }

  return (
    <div className='newPageContainer'>

      <div className=''>
        <h5>Special Editions</h5>

        <div className='gridThree shallow'>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/1969-eileen-myles' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/1969_Side_v2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>1969</div>
                <div className='nb-author'>Eileen Myles</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798995641001'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/by-surprise-henri-michaux' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/Michaux_Side_v2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>

                <div className='nb-title'>By Surprise</div>
                <div className='nb-author'>Henri Michaux</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416581'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/on-the-lords-prayer-simone-weil' className='gridThree_bookCover' style={{
                background: `url(../../Series-Special/Weil_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>On the Lord's Prayer</div>
                <div className='nb-author'>Simone Weil</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416598'} />
              </div>
            </div>
          </div>


        </div>

        <h5>Series III</h5>

        <div className='gridThree'>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/kafka-and-i-can-xue' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/CanXue_06_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Kafka & I</div>
                <div className='nb-author'>Can Xue</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798989378074'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/history-of-the-dolls-jesse-ball' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/JesseBall_07_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>

                <div className='nb-title'>The History of the Dolls and What They Did</div>
                <div className='nb-author'>Jesse Ball</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416567'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/mishimas-head-mario-bellatin' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/MarioBellatin_08_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Mishima's Head</div>
                <div className='nb-author'>Mario Bellatin</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416550'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/space-opera-georgi-gospodinov' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/GeorgiGospodinov_09_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Space Opera</div>
                <div className='nb-author'>Georgi Gospodinov</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416574'} />
              </div>
            </div>
          </div>


          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/love-never-dies-eka-kurniawan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/EkaKurniawan_10_Mockup2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Love Never Dies</div>
                <div className='nb-author'>Eka Kurniawan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416543'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/fuck-journal-bob-flanagan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/Flanagan_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Fuck Journal</div>
                <div className='nb-author'>Bob Flanagan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416536'} />
              </div>
            </div>
          </div>

        </div>

        <h5>Series II</h5>

        <div className='gridThree'>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/life-story-mckenzie-wark' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/McKenzieWark_01_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}></Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Life Story</div>
                <div className='nb-author'>McKenzie Wark</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378067'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/grocery-list-bora-chung' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/BoraChung_02_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}></Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Grocery List</div>
                <div className='nb-author'>Bora Chung</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416529'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/frontier-index-raymond-pettibon-mike-top' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/RaymondPettibonTopp_05_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Frontier Index</div>
                <div className='nb-author'>Raymond Pettibon & Mike Topp</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416512'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/insistence-as-a-fine-art-enrique-vila-matas' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/EnriqueVila-Matas_03_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls '>
              <div className='gridThree_description'>
                <div className='nb-title'>Insistence as a Fine Art</div>
                <div className='nb-author'>Enrique Vila-Matas</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798990416505'} />
              </div>
            </div>
          </div>


          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/kuruntokai-vivek-narayanan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/VivekNarayanan_04_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>

            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Kuruntokai and Its Mirror</div>
                <div className='nb-author'>Vivek Narayanan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378098'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/fan-mail-frank-letters-crank-calls-cookie-mueller' className='gridThree_bookCover' style={{
                background: `url(../../Series-Two/Fanmail_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Fan Mail, Frank Letters and Crank Calls</div>
                <div className='nb-author'>Cookie Mueller</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378081'} />
              </div>
            </div>
          </div>
        </div>


        <h5>Series I</h5>

        <div className='gridThree'>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/on-my-painting-max-beckmann' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/MaxBeckman_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>On My Painting</div>
                <div className='nb-author'>Max Beckmann</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378005'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/the-ice-storm-john-ashbery' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/Ashbery_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Ice Storm</div>
                <div className='nb-author'>John Ashbery</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378012'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/feminine-hijinx-dodie-bellamy' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/DodieBellamy_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Feminine Hijinx</div>
                <div className='nb-author'>Dodie Bellamy</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378029'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/garden-of-ashes-cookie-mueller' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/Garden_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Garden of Ashes</div>
                <div className='nb-author'>Cookie Mueller</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378036'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/bread-and-water-eileen-myles' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/B-w_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Bread and Water</div>
                <div className='nb-author'>Eileen Myles</div>
              </div>
              <div>
                <AddToCart context='landing' id={'9798989378043'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/the-lie-of-the-truth-rene-daumal' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/ReneDaumal_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Lie of the Truth</div>
                <div className='nb-author'>René Daumal</div>
              </div>
              <div>
                <AddToCart context='landing' id={'9798989378050'} />
              </div>
            </div>
          </div>
        </div>



      </div>
    </div >
  )
}